// frontend/src/pages/recommendationTickedTotals.js
//
// A recommendation row's totals over the lines the merchant left ticked. The
// row holds the server's totals over every line (PORecommendationListSerializer);
// the unticked lines are taken off them here, at display time, so a reload of
// the row keeps the merchant's choice and a line the server added since counts
// as ticked.

/**
 * A line's value, priced the way the server prices it
 * (core/services/cost_valuation.py value_at_unit_price): zero quantity is
 * worth zero whatever the cost, and a quantity at an unknown cost is unknown
 * (null) — never priced at zero.
 */
export function lineValue(line) {
  if (line.RecommendedQuantity === 0) return 0;
  if (line.unit_cost == null) return null;
  return line.RecommendedQuantity * parseFloat(line.unit_cost);
}

/**
 * @param {object|undefined} row  the server's row (undefined while it loads)
 * @param {Map<number, object>|undefined} unticked  lineId → line, for the
 *   lines the merchant unticked; undefined when every line is ticked
 * @returns the row, with `total_quantity`, `total_value` and `uncosted_lines`
 *   over the ticked lines
 */
export function tickedTotals(row, unticked) {
  if (!unticked) return row;
  let quantity = 0;
  let value = 0;
  let uncosted = 0;
  unticked.forEach((line) => {
    quantity += line.RecommendedQuantity;
    const lineWorth = lineValue(line);
    if (lineWorth === null) uncosted += 1;
    else value += lineWorth;
  });
  const lines = row.line_count - unticked.size;
  const uncostedLines = row.uncosted_lines - uncosted;
  let totalValue;
  if (lines === 0) totalValue = 0;
  // Nothing left ticked can be priced: the total is unknown, not 0.
  else if (uncostedLines === lines) totalValue = null;
  else totalValue = parseFloat(row.total_value) - value;
  return {
    ...row,
    total_quantity: row.total_quantity - quantity,
    total_value: totalValue,
    uncosted_lines: uncostedLines,
  };
}
